// extracted by mini-css-extract-plugin
export default {"message":"StatusMessage--message--53e72d","header":"StatusMessage--header--e6a367","icon":"StatusMessage--icon--e07036","description":"StatusMessage--description--f48eeb"};